import { FC } from "react";

import styles from "./styles.module.scss";

const WHATSAPP_URL = "https://wa.me/33745086824";
const WHATSAPP_NUMBER = "07 45 08 68 24";

const AssistanceBox: FC = () => (
    <aside className={styles.box}>
        <p className={styles.title}>
            <span className={styles.badge} aria-hidden="true">
                ?
            </span>
            Besoin d&apos;assistance ?
        </p>
        <p className={styles.text}>Contactez-nous sur Whatsapp :</p>
        <a
            className={styles.button}
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <svg
                className={styles.icon}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                aria-hidden="true"
                focusable="false"
            >
                <circle cx="9" cy="9" r="9" fill="#25D366" />
                <path
                    fill="#fff"
                    d="M12.55 10.7c-.2-.1-1.15-.57-1.33-.63-.18-.07-.31-.1-.44.1-.13.2-.5.63-.62.76-.11.13-.23.15-.43.05-.2-.1-.84-.31-1.6-.99-.59-.53-.99-1.18-1.1-1.38-.12-.2-.01-.3.09-.4.09-.09.2-.23.3-.35.1-.11.13-.2.2-.33.06-.13.03-.25-.02-.35-.05-.1-.44-1.06-.6-1.45-.16-.38-.32-.33-.44-.34h-.38c-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66 0 .98.71 1.92.81 2.05.1.13 1.4 2.14 3.39 3 .47.2.84.33 1.13.42.47.15.9.13 1.24.08.38-.06 1.16-.47 1.32-.93.16-.46.16-.85.11-.93-.04-.08-.18-.13-.38-.23z"
                />
            </svg>
            {WHATSAPP_NUMBER}
        </a>
        <p className={styles.note}>
            (seules les demandes par Whatsapp seront prises en compte)
        </p>
    </aside>
);

export default AssistanceBox;
